import {useEffect, useState, useRef} from 'react';
import {getTags, tagPlants} from "../../api/Api";
import {AutoComplete, Button, Col, Row} from "antd";
import {handleNoSession} from "../../util/errorUtils";

export const TagSelectWidget = ({plantId, refresh, onRefresh, onApiFail, disabled, label, props}) => {
    const [tags, setTags] = useState([]);
    const [options, setOptions] = useState([]);
    const [active, setActive] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        getTags().then(r => {
            setTags(r.map(t => {
                return {
                    ...t,
                    key: t.id,
                }
            }))
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });
    }, [refresh, onApiFail]);

    const onChange = (data) => {
    }

    const onSearch = (text) => {
        const newOptions = tags.filter(line => {
            const ltext = text.toLowerCase();
            return line.name.toLowerCase().includes(ltext);
        }).map(val => {
            return {
                value: `${val.name}`,
                item: val,
                key: val.id,
            }
        });
        setOptions(newOptions)
    }

    const select = (val, option) => {
        const {id: tagId} = option.item;
        const plantIds = Array.isArray(plantId) ? plantId : [plantId];
        tagPlants(tagId, plantIds).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            handleNoSession(e);
        })
        setActive(false);
    }

    const onBlur = () => {
        setActive(false);
    }

    const onClick = () => {
        setActive(true);

        setTimeout(() => {
            inputRef.current.focus();
        }, 20)
    }

    const rowStyle = {
        marginTop: "5px",
        marginBottom: "5px"
    }

    const autoCompleteStyle = {
        width: 350
    }

    const buttonLabel = (label) ? label : `Add Tag`;

    if (active) {
        return <div>
            <Row style={rowStyle}>
                <Col span={8} onBlur={onBlur}>
                    <AutoComplete placeholder={"Tag"} style={autoCompleteStyle} options={options} onSelect={select}
                                  onSearch={onSearch} onChange={onChange} onBlur={onBlur} ref={inputRef}/>
                </Col>
            </Row>
        </div>
    } else {
        return <Button onClick={onClick} disabled={disabled}>{buttonLabel}</Button>
    }
}